module.exports = __webpack_public_path__ + "static/media/board-cell.f20a5edd.svg";